import { loadState, saveState } from '../../../libs/persist';

const STORE_KEY = 'help';
let loaded = loadState(STORE_KEY) || [];

const state = {
	entities: loaded.entities || [],
	helpData: loaded.helpData || [],
	selectedEntity: loaded.selectedEntity,
};

const mutations = {
	SET_ENTITIES_DATA(state, entities) {
		state.entities = entities;
		saveState(STORE_KEY, state);
	},
	SET_HELP_DATA(state, helpData) {
		state.helpData = helpData;
		saveState(STORE_KEY, state);
	},
	SET_ENTITY_DATA(state, entity) {
		state.selectedEntity = entity;
		saveState(STORE_KEY, state);
	},
};

const actions = {
	setEntities({ commit }, entities) {
		commit('SET_ENTITIES_DATA', entities);
	},
	setHelpData({ commit }, helpData) {
		commit('SET_HELP_DATA', helpData);
	},
	setEntityData({ commit }, entity) {
		commit('SET_ENTITY_DATA', entity);
	},
};

const getters = {
	selectEntities: (state) => state.entities,
	currentHelpData: (state) => state.helpData,
	selectedEntity: (state) => state.selectedEntity,
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
